import React, { useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import MapObject from './MapObject';
import { selectChairsObject } from '../../store/Chairs/ChairsSlice';

const MapObjects = ({ mapRef, avatarBounds }) => {
  const overlays = useRef({});
  const { roomsData } = useSelector((state) => state.MapDisplay);

  // 1. Transformer roomsData en une liste d'objets plate (flatten)
  const dynamicObjects = useMemo(() => {
    if (!roomsData) return [];

    return roomsData.flatMap((room) => {
      // On vérifie si la salle a des objets
      if (!room.objects || !Array.isArray(room.objects)) return [];

      return room.objects.map((obj) => ({
        id: obj.id, 
        name: obj.name ,
        image: obj.image_url ,
        roomId: room.room_id,
        lat: obj.lat,
        lng: obj.lng,
        ...obj 
      }));
    });
  }, [roomsData]);

  useEffect(() => {
    const activeIds = dynamicObjects.map(o => `object-${o.id}`);
    
    Object.keys(overlays.current).forEach((objId) => {
      if (!activeIds.includes(objId)) {
        overlays.current[objId].remove();
        delete overlays.current[objId];
      }
    });
  }, [dynamicObjects]);

  return (
    <>
      {dynamicObjects.map((obj) => (
        <MapObject
          key={`object-${obj.id}`}
          object={obj}
          objectBounds={avatarBounds}
          mapRef={mapRef}
          overlays={overlays}
        />
      ))}
    </>
  );
};

export default MapObjects;